import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
export default (function (array, size) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var chunks = [];
  if (offset) chunks.push(array.splice(0, offset));
  var numberOfChunks = Math.ceil(array.length / size);
  var i = 0;
  while (i < numberOfChunks) {
    chunks.push(array.splice(0, size));
    i += 1;
  }
  return chunks;
});